import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Objectify } from '../../shared/utilities/shared.functions';
import { CaseFilesFunctions, FileFolder, FileFunctions, OSDocument, OSFile, UploadCounter } from './case-files-functions';
import * as api from '../../shared/api/apihandler';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { IdName } from 'app/shared/models/standard.models';

@Component({
    selector: 'case-files',
    templateUrl: './case-files.component.html',
    styleUrls: ['./case-files.component.css']
})
export class CaseFilesComponent implements OnInit, OnChanges, OnDestroy {
    @Input() caseId;
    @Input() propertyId;
    @Input() assetId;
    @Input() serviceId;
    @Input() tiny: boolean = false; // use minimized version
    @Input() restrict: boolean = false; // hide add/delete options

    f = new FileFunctions(this.http);
    caseFunctions = new CaseFilesFunctions();
    all: FileFolder[] = []; // all files and folders attached to the case
    current: FileFolder[] = []; // current folder
    folder: string | null = null; // current folder Id
    folders: any[];
    user = localStorage.getItem('bearer');
    filesSelected: 'all' | 'some' | 'none' = 'none';
    fileHov: boolean = false;
    dontDrop: boolean = false;
    crumbs: any[] = [];
    newFolder: FileFolder | null = null;
    openFolders: string[] = [];
    standardFolders;
    viewFile;
    displayDoc;
    rotateImage: number = 0;
    scaleImage: number = 1;
    toBeDeleted: string[] = [];
    testingMode: boolean = false;
    gettingOSfiles: boolean = false;
    OSFiles;
    isTaurus: boolean = false;
    isAdmin: boolean = false;

    constructor(private http: HttpClient, private translate: TranslateService, private toastr: ToastrService, private sanitize: DomSanitizer, private shared: SharedDataService, private ref: ChangeDetectorRef) { }


    ngOnInit(): void {
        let a = document.getElementById('caseFilesContainer') as HTMLElement;
        if (!!a && a.clientWidth < 700) this.tiny = true;

    }

    ngOnChanges(c: SimpleChanges) {
        if (!!c.caseId && !!c.caseId.currentValue && c.caseId.currentValue != c.caseId.previousValue) this.getCaseFiles();
        if (!!c.propertyId && !!c.propertyId.currentValue && c.propertyId.currentValue != c.propertyId.previousValue) this.getPropertyFiles();
        if (!!c.assetId && !!c.assetId.currentValue && c.assetId.currentValue != c.assetId.previousValue) this.getAssetFiles();
        if (!!c.serviceId && !!c.serviceId.currentValue && c.serviceId.currentValue != c.serviceId.previousValue) this.getServiceFiles();
        window.addEventListener('resize', (e) => this.checkWidth(e));
    }

    ngOnDestroy(): void {
        window.removeEventListener('resize', (e) => this.checkWidth(e));
    }

    checkWidth(e) {
        let a = document.getElementById('caseFilesContainer') as HTMLElement;
        if (!!a && a.clientWidth < 800) this.tiny = true;
        else this.tiny = false;
        this.ref.detectChanges();
    }

    getCaseFiles() {
        this.toBeDeleted = [];
        this.f.getFilesOnCase(this.caseId).subscribe({
            next: (f: any) => {
                let files = CaseFilesFunctions.extractFiles(f.files as any[]);
                let folders = CaseFilesFunctions.remapObject(f.files as any[]);
                if (localStorage.getItem('integration') == '58ecfda6-79a6-4507-80ac-29b6d025360b' && this.caseId) folders.push({ folderId: 'OS', folderName: 'OS', parentFolderId: null });
                this.all = CaseFilesFunctions.joinFilesAndFolders(files, folders, this.openFolders);
                if (!!this.folder) this.setFolder(this.folder)
                this.translateFolderNames();
            },
            error: (err) => console.error(err)
        })
    }

    getPropertyFiles() {
        this.toBeDeleted = [];
        this.f.getProperty(this.propertyId).subscribe({
            next: (f: any) => {
                let files = CaseFilesFunctions.extractFiles(f.files.files as any[]);
                let folderLess = f.files.filesWithoutFolder.map(x => ({ ...x, parentFolderId: null }))
                let folders = CaseFilesFunctions.remapObject(f.files.files as any[]);
                this.all = CaseFilesFunctions.joinFilesAndFolders(files.concat(folderLess), folders, this.openFolders);
                this.isAdmin = !!localStorage.getItem('guards') ? !!JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'SettingsAccess') : false;
                if (!!this.shared.compInfo && this.shared.compInfo.id == '2605daad-d63b-4ccb-9c35-bce53c4becd4') this.isTaurus = true;
                this.sortFolderMenu();
                this.setFolder(this.folder)
            }
        })
    }

    getAssetFiles() {
        this.toBeDeleted = [];
        this.f.getFilesOnAsset(this.assetId).subscribe({
            next: (f: any) => {
                let files = CaseFilesFunctions.extractFiles(f as any[]);
                let folders = CaseFilesFunctions.remapObject(f.map(x => ({ folderId: x.id, parentFolderId: x.parentFolderId, folderName: x.name })) as any[]);
                this.all = CaseFilesFunctions.joinFilesAndFolders(files, folders, this.openFolders);
                this.translateFolderNames();
            }
        })
    }

    getServiceFiles() {
        this.f.getFilesOnService(this.serviceId).subscribe({
            next: (f: any) => console.log(f)
        })
    }

    rowClick(x) {
        if (!!x.base64 && !!x.fileType) {
            console.log('this file is base64 format');
            x.fileType = x.fileType.toLowerCase();
            let a = document.createElement('a');
            switch (x.fileType) {
                case '71e32e6a-ff53-4ce2-9704-1c9fc94212f1': // PDF 
                    var blob = this.b64toBlob(x.baseString, 'application/pdf');
                    break;
                case 'c1b89127-cf88-4477-ba7b-6040b0b8b5a6':
                case '3b5f5211-0f38-451e-8531-118fd05cd546':
                case 'd901d49c-a6ea-476f-a126-41c0317c0780':
                case 'f8c29c93-be8b-44cf-bc8b-429be1014b13':
                case 'c1b89127-cf88-4477-ba7b-6040b0b8b5a6':
                case '1370cf6c-d723-4bbd-9e9f-67455bb31d49':
                case '399e7c75-418b-4052-872a-6fc1dcaee5a2':
                case '01d369aa-b605-401d-98c7-79fa2556c016':
                case 'e35ececd-a40c-42ee-b49c-7c18e73b6b8b':
                case '3467fd0e-0d36-41af-bcd5-7fc164c885e8':
                case 'ea9b43ee-3399-42f4-923e-af5646e94b39':
                case '418fefab-7177-4854-8676-c4198c737134':
                case 'ba7b4564-2037-4135-9e50-f12df3ecd768':
                case 'c4ae7891-6179-40fe-9f53-fb52f0889abc':
                case 'd901d49c-a6ea-476f-a126-41c0317c0780': // IMAGES
                    var blob = this.b64toBlob(x.baseString, 'image/' + x.extension);
                    break;
                case '00ace83e-2be7-4af7-a377-3eb7fdabccc6':
                case '432f841b-6ce5-4ebb-afc3-edf8ba5134ed':
                case '69e80cce-7ff3-42c1-92ce-75137e557f94':
                case '0fce3562-66a4-403a-8dcd-8818db0ca115':
                case 'b5478ced-5fe2-43de-af8d-a33cf9a09b13': // WORD/EXCEL
                    var blob = this.b64toBlob(x.baseString, 'application/' + x.extension);
                    break;
                default:
                    break;
            }
            document.body.appendChild(a);
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = String(x.fileName);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        } else {
            switch (x.type) {
                case 'file': {
                    this.viewFile = x;
                    this.rotateImage = 0;
                    this.scaleImage = 1;
                    document.getElementById('viewFileModalOpener').click();
                    if (x.extension == '.pdf') {
                        this.displayDoc = fetch(this.getURL(x.id)).then(res => res.blob()).then(blob => {
                            this.displayDoc = URL.createObjectURL(blob)
                        })
                    }
                    break
                }
                case 'folder': {
                    this.setFolder(x.id);
                    break
                }
            }
        }
    }


    b64toBlob(b64Data: any, contentType: string) {
        contentType = contentType || '';
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    back() {
        this.crumbs.pop();
        this.setFolder(!!this.crumbs.length ? this.crumbs[this.crumbs.length - 1].id : null);
    }

    setFolder(id: string | null) {
        if (!id && !this.tiny && !this.propertyId) return
        else {
            if (id != 'OS') {
                this.current = this.all.filter(x => x.parentId == id).sort((a, b) => !!a.name && !!b.name && a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
                this.folder = id;
                this.current.filter(x => x.type == 'folder').forEach(x => { x.count = CaseFilesFunctions.countFilesInFolder(this.all, x.id) });
                this.filesSelected = 'none';
            }
            else if (id == 'OS' && !!this.caseId) {
                // Load and map OS files.
                this.gettingOSfiles = true;
                this.current = [];
                this.f.getOSFiles(this.caseId).subscribe({
                    next: (data: { files: OSFile[], docs: OSDocument[] }) => this.osFiles(data),
                    error: (error) => console.warn("Couldn't get files from OS", error),
                    complete: () => this.gettingOSfiles = false
                })
            }
            // this.filesSelected = CaseFilesFunctions.checkCurrentSelected(this.current);
            if (!id) this.crumbs = [];
            else if (!!id && !this.crumbs.find(x => x.id == id)) this.crumbs.push(this.all.find(x => x.id == id));
            else if (!!id && !!this.crumbs.find(x => x.id == id)) this.crumbs.splice(this.crumbs.findIndex(x => x.id == id) + 1)

        }
    }

    async osFiles(data: { files: OSFile[], docs: OSDocument[] }) {
        let x = await this.caseFunctions.convertOSFiles(data, this.sanitize);
        this.OSFiles = x.files.concat(x.docs);
    }

    setFolderFromFolder(id: string | null) {
        this.current.forEach(x => x.selected = false);
        this.setFolder(id);
        // this.current = this.all.filter(x => x.parentId == id);
        // this.folder = id;
        // this.current.filter(x => x.type == 'folder').forEach( x => { x.count = CaseFilesFunctions.countFilesInFolder(this.all, x.id) });
        // this.filesSelected = 'none';
        this.crumbs = [];
        this.constructCrumbsFromFolderId(id);
    }

    constructCrumbsFromFolderId(id) {
        if (!!this.caseId) {
            let selectedFolder = this.all.find(x => x.id == id);
            this.crumbs.unshift(selectedFolder);
            if (!!selectedFolder.parentId) this.constructCrumbsFromFolderId(selectedFolder.parentId);
        }
    }

    async translateFolderNames() {
        this.translate.get(['Folder.Customer', 'Folder.Technician', 'Folder.Administrator', 'Folder.Company', 'Folder.Manuals']).subscribe(translations => {
            let c = this.all.find(x => x.name.toLowerCase() == 'folder.customer');
            let comp = this.all.find(x => x.name == 'Folder.Company')
            let t = this.all.find(x => x.name == 'folder.technician');
            let a = this.all.find(x => x.name == 'folder.admin');
            let m = this.all.find(x => x.name == 'Folder.Manuals')
            if (this.caseId) {
                this.standardFolders = {
                    customer: translations['Folder.Customer'],
                    technician: translations['Folder.Technician'],
                    administrator: translations['Folder.Administrator']
                }
            } else if (this.assetId) {
                this.standardFolders = {
                    customer: translations['Folder.Customer'],
                    company: translations['Folder.Company'],
                    manuals: translations['Folder.Manuals'],
                }
            }

            if (!this.folder && !!c) this.setFolder(c.id);
            else this.setFolder(this.folder);

            if (!!c) c.name = translations['Folder.Customer'];
            if (!!t) t.name = translations['Folder.Technician'];
            if (!!a) a.name = translations['Folder.Administrator'];
            if (!!comp) comp.name = translations['Folder.Company'];
            if (!!m) m.name = translations['Folder.Manuals'];
            this.sortFolderMenu();
        });
    }

    selectFile(x: FileFolder) {
        x.selected = !x.selected;
        if (this.folder != 'OS') this.filesSelected = CaseFilesFunctions.checkCurrentSelected(this.current);
        else this.filesSelected = CaseFilesFunctions.checkCurrentSelected(this.OSFiles);
    }

    selectedInCurrent(to: boolean) {
        if (this.folder != 'OS') {
            this.current.forEach(x => x.selected = to);
            this.filesSelected = CaseFilesFunctions.checkCurrentSelected(this.current);
        }
        else {
            this.OSFiles.forEach(x => x.selected = to);
            this.filesSelected = CaseFilesFunctions.checkCurrentSelected(this.OSFiles);
        }
    }

    async addFiles(files) {
        this.fileHov = false;
        if (!!files && files.length > 0) {
            let count = 0;
            for (let file of files) {
                if (!!this.caseId) {
                    this.f.oldFileUploadToCase(this.caseId, this.folder, file).subscribe({
                        next: (data) => { count += 1; },
                        error: (err) => { console.error('File could not be attached to case: ', this.caseId, err); count += 1; },
                        complete: () => { if (count == files.length) setTimeout(() => this.reload(), 500) }
                    });
                }
                else if (!!this.propertyId) {
                    this.f.oldFileUploadToProperty(this.propertyId, this.folder, file).subscribe({
                        next: (data) => { count += 1; },
                        error: (err) => { console.error('File could not be attached to case: ', this.caseId, err); count += 1; },
                        complete: () => { if (count == files.length) setTimeout(() => this.reload(), 500) }
                    });
                }
            }
            if (!!this.assetId) {
                this.f.oldFileUploadToAsset(this.assetId, files, this.folder).subscribe({
                    next: (data: any) => console.log(data),
                    complete: () => this.getAssetFiles()
                })
            }
            else if (!!this.serviceId) {
                console.log('add files to service', files)
                this.f.oldFileUploadToService(this.serviceId, files, this.folder).subscribe({
                    next: (data: any) => console.log(data),
                    complete: () => this.getServiceFiles()
                })
            }
            // this.f.uploadFilesToAsset(this.assetId, files, this.folder).subscribe({
            //   complete:() => this.getAssetFiles()
            // })}
        }
    }

    async droppedFiles(event) {
        event.preventDefault();
        this.fileHov = false;
        const uploadFiles = await this.f.uploadFileCount(event.dataTransfer, null);
        // if no folders being uploaded, use legacy
        if (!uploadFiles.folderCount) {
            // Normal upload.
            let files = event.dataTransfer.files;
            if (!!files && files.length > 0) {
                let count = 0;
                for (let file of files) {
                    if (!!this.caseId) {
                        this.f.oldFileUploadToCase(this.caseId, this.folder, file).subscribe({
                            next: (data) => { count += 1; },
                            error: (err) => { console.error('File could not be attached to case: ', this.caseId, err); count += 1; },
                            complete: () => { if (count == files.length) setTimeout(() => this.reload(), 500) }
                        });
                    }
                    else if (!!this.propertyId) {
                        this.f.oldFileUploadToProperty(this.propertyId, this.folder, file).subscribe({
                            next: (data) => { count += 1; },
                            error: (err) => { console.error('File could not be attached to case: ', this.caseId, err); count += 1; },
                            complete: () => { if (count == files.length) setTimeout(() => this.reload(), 500) }
                        });
                    }
                }
                if (!!this.assetId) {
                    this.f.oldFileUploadToAsset(this.assetId, files, this.folder).subscribe({
                        next: (data: any) => console.log(data),
                        complete: () => this.getAssetFiles()
                    })
                }
                else if (!!this.serviceId) {
                    console.log('add files to service', files)
                    this.f.oldFileUploadToService(this.serviceId, files, this.folder).subscribe({
                        next: (data: any) => console.log(data),
                        complete: () => this.getServiceFiles()
                    })
                }
                // this.f.uploadFilesToAsset(this.assetId, files, this.folder).subscribe({
                //   complete:() => this.getAssetFiles()
                // })}
            }
        }
        else {
            let type: FileTargetType = (!!this.caseId ? 'case' : !!this.propertyId ? 'property' : !!this.assetId ? 'asset' : 'service');
            let id = this[type + 'Id'];
            console.log({ type: type, id: id })
            this.batchUpload(uploadFiles, { type: type, id: id }, this.folder);
        }
    }

    async batchUpload(uploadFiles: UploadCounter, is: { id: string, type: FileTargetType }, folderId) {
        console.log('Batch upload started', JSON.parse(JSON.stringify(uploadFiles)))
        // Set files and folder access.
        let access = null; // Maybe shouold have a different standard?
        if (this.crumbs && this.crumbs.length) access = this.crumbs[0].fileAccess;

        /**
         * 1. Filter all files that has no parent OR has current folderId.
         * ---------------------------------------------------------------
         * Recursive starts with folderId null (if no standard folders)
         * and files uploaded outside of folder has no parent.
         */
        const firstFiles = uploadFiles.files.filter(x => !x.parent || x.parent == folderId);
        // console.log('There should be a first file!', firstFiles)
        if (firstFiles.length) {
            uploadFiles.files = uploadFiles.files.filter(x => x.parent !== null && x.parent !== folderId);
            let result = await this.f.uploadTo(is, firstFiles, folderId);
            uploadFiles.uploadedFiles += (result.success.length + result.fail.length);
            // console.log(result, uploadFiles.uploadedFiles)
        }

        /**
         * 2. Filter out folders to create and attach.
         * -------------------------------------------
         * Folders need to be uploaded before files can be attached to it.
         */
        const rootFolders = uploadFiles.folders.filter(x => x.parent == null || x.parent == folderId); // current folders to be uploaded
        const newFolders = rootFolders.map(x => ({ ...new FileFolder(), type: 'folder', parentId: folderId, fileAccess: access, name: x.folder.name }));
        uploadFiles.folders = uploadFiles.folders.filter(x => x.parent !== null && x.parent !== folderId); // filter current folders for recursive
        let attachedFolders;
        if (!!newFolders && newFolders.length) {
            attachedFolders = await this.f.uploadFoldersTo(is, newFolders, folderId); // Uploading folders.
            uploadFiles.uploadedFolders += attachedFolders.length;
        }
        if (!!attachedFolders && attachedFolders.length) {
            // Remap folders and files, to get the newly aquired folderIds
            await attachedFolders.forEach(attached => {
                uploadFiles.folders.forEach(folder => {
                    if (folder.parent === attached.folder.name) folder.parent = attached.id;
                });
                uploadFiles.files.forEach(file => {
                    if (file.parent === attached.folder.name) file.parent = attached.id;
                });
            });
            /**
             * 3. Rerun function for each folder.
             */
            attachedFolders.forEach(x => {
                // console.log('uploading more files for folder:', x)
                this.batchUpload(uploadFiles, is, x.id);
            });
        }
        else {
            this.reload();
        }

    }

    /**
     * Triggered by a folder drop event.
     * Filters selected files in current folder view.
     * Files will be unselected on reload
     * Has to check where the file belongs (in subfolder of own system, partner system or virtual folder) and where the target folder belongs
     * 
     *  System to system (move files)
     *  System to partner or Partner to system ( copy files )
     *    !! Moving a folder to/from partner folder, requires creating new folders as you can not copy folders.
     *  Virtual folder to system or System to Virtual folder.
     * 
     * ToDo:
     * If files are dragged to a partner file, it should be copied, not moved, and vice versa.
     * Remove the possibility to drop a folder into its own child folder.
     * Files can not moved to a folder in the file list. Only dropped in the folder tree.
     */
    async moveFiles(event) {
        // let targetFolderType: 'system' | 'partner' | 'virtual';
        // let originFolderType: 'system' | 'partner' | 'virtual';
        let target = this.findRootFolder(this.all.find(x => x.id == event.folderId));
        let origin = this.findRootFolder(this.all.find(x => x.id == this.folder));
        let count = this.current.filter(x => !!x.selected).length;
        if (!!this.caseId) {
            if (origin == 'system' && target == 'system') {
                for (let x of this.current.filter(x => !!x.selected)) {
                    if (x.type == 'file') {
                        this.f.moveFileToFolder(this.caseId, x.id, event.folderId, false).subscribe({
                            next: () => { },
                            error: (err) => {
                                console.log('File failed while moving', x)
                            },
                            complete: () => {
                                count -= 1;
                                if (count == 0) {
                                    this.reload()
                                }
                            }
                        })

                    }
                    else if (x.type == 'folder') {
                        this.f.moveFolderToFolder(x.id, event.folderId).subscribe({
                            next: () => { },
                            error: (err) => {
                                console.log('File failed while moving', x)
                            },
                            complete: () => {
                                count -= 1
                                if (count == 0) {
                                    this.reload()
                                }
                            }
                        })
                    }
                };
            }
            else if (origin == 'virtual' && ['system', 'partner'].includes(target)) {
                // create files, upload files, attach files to folder
                let files = this.OSFiles.filter(x => x.selected).map(x => {
                    return {
                        fileName: x.fileName,
                        fileType: x.fileType,
                        base64: x.baseString
                    }
                });
                this.f.importFilesFromOs(this.caseId, files, event.folderId).subscribe({
                    next: () => { console.log('Files imported') },
                    error: (err) => { console.warn("Couldn't import files from OS", err) },
                    complete: () => setTimeout(() => this.reload(), 1000)
                });

            }
            else if (['partner', 'system'].includes(origin) && target == 'virtual') {
                // Sort out the files selected in this folder
                let selection = this.current.filter(x => x.type == 'file' && x.selected).map(x => x.id);
                this.f.filesToOS(this.caseId, selection).subscribe({
                    next: () => console.log('Images sent to OS')
                });

            }
            else if (origin == 'system' && target == 'partner' || origin == 'partner' && target == 'system') {
                for (let x of this.current.filter(x => !!x.selected)) {
                    if (x.type == 'file') {
                        this.f.moveFileToFolder(this.caseId, x.id, event.folderId, true).subscribe({
                            next: () => { },
                            error: (err) => {
                                console.log('File failed while moving', x)
                            },
                            complete: () => {
                                count -= 1;
                                if (count == 0) {
                                    this.reload()
                                }
                            }
                        })

                    }
                    else if (x.type == 'folder') {
                        this.f.moveFolderToFolder(x.id, event.folderId).subscribe({
                            next: () => { },
                            error: (err) => {
                                console.log('File failed while moving', x)
                            },
                            complete: () => {
                                count -= 1
                                if (count == 0) {
                                    this.reload()
                                }
                            }
                        })
                    }
                };
            }
            else {
                // Folders that should get the target folder as parentId
                let topFolders = this.current.filter(x => !!x.selected && x.type == 'folder');
                let topFiles = this.current.filter(x => !!x.selected && x.type == 'file');
                let findSubs: string[] = [];
                for (let x of topFolders) {
                    findSubs = findSubs.concat(await this.addDeletablesFromFolder(x))
                };
                // make sure a subFolders does not include a top folder
                findSubs = findSubs.filter(x => !topFolders.map(x => x.id).includes(x));
                let subFolders = this.all.filter(x => findSubs.includes(x.id) && x.type == 'folder');
                let subFiles = this.all.filter(x => findSubs.includes(x.id) && x.type == 'file');
                let count = topFolders.length + topFiles.length + subFolders.length + subFiles.length;
                this.f.duplicateFolders(this.caseId, [...topFolders, ...subFolders]).subscribe({
                    next: (data) => {
                        console.log(data)
                        // data is object keys are oldFolder ids and values are the new.
                        // For each top folder, move folder with new id to event.folderId
                        topFolders.forEach(x => {
                            this.f.moveFolderToFolder(data[x.id], event.folderId).subscribe({
                                next: () => {
                                    count -= 1;
                                    if (count == 0) this.getCaseFiles();
                                }
                            })
                        });
                        // copy top files to event.folderId
                        topFiles.forEach(x => {
                            this.f.moveFileToFolder(this.caseId, x.id, event.folderId, true).subscribe({
                                next: () => {
                                    count -= 1;
                                    if (count == 0) this.getCaseFiles();
                                }
                            })
                        });
                        // for each sub folder, move to new parent id
                        subFolders.forEach(x => {
                            this.f.moveFolderToFolder(data[x.id], data[x.parentId]).subscribe({
                                next: () => {
                                    count -= 1;
                                    if (count == 0) this.getCaseFiles();
                                }
                            })
                        });
                        // for each sub file, copy to new parent id
                        subFiles.forEach(x => {
                            this.f.moveFileToFolder(this.caseId, x.id, data[x.parentId], true).subscribe({
                                next: () => {
                                    count -= 1;
                                    if (count == 0) this.getCaseFiles();
                                }
                            })
                        })
                    }
                });
            }
        }
        else if (!!this.propertyId) {
            // for(let x of this.current.filter(x => !!x.selected)){
            //   if(x.type == 'file'){

            //   }
            //   else if(x.type == 'folder'){}
            // }
        }
        else if (!!this.assetId) {
            for (let x of this.current.filter(x => !!x.selected)) {
                if (x.type == 'file') { }
                else {
                    this.f.moveAssetFolderToFolder(x.id, event.folderId).subscribe({
                        complete: () => {
                            count -= 1
                            if (count == 0) {
                                this.reload()
                            }
                        }
                    })
                }
            }
        }
    };

    findRootFolder(f) {
        if (!!f.parentId) return this.findRootFolder(this.all.find(x => x.id == f.parentId));
        else {
            if (f.name == 'OS') return 'virtual';
            if ([this.standardFolders.customer, this.standardFolders.technician, this.standardFolders.administrator, this.standardFolders].includes(f.name)) return 'system';
            else return 'partner'
        }
    }

    async deleteSelected() {
        /**
         * if only files are selected, delete selected files
         * if a folder is selected, files and subFolders need to be collected in order to delete them all;
         */
        let subFiles: string[] = [];
        let selected = this.all.filter(x => !!x.selected);
        this.toBeDeleted = selected.filter(x => x.type == 'file').map(x => x.id);
        for (let x of selected.filter(x => x.type == 'folder')) {
            subFiles = subFiles.concat(await this.addDeletablesFromFolder(x))
        }
        this.toBeDeleted = this.toBeDeleted.concat(subFiles);
    }

    async addDeletablesFromFolder(f: FileFolder): Promise<string[]> {
        let files: string[] = this.all.filter(x => x.type == 'file' && x.parentId == f.id).map(x => x.id);
        for (let x of this.all.filter(x => x.type == 'folder' && x.parentId == f.id)) {
            files = files.concat(await this.addDeletablesFromFolder(x))
        }
        files.push(f.id);
        return files
    }

    delete() {
        this.openFolders = this.checkOpenedFolders(this.all.filter(x => x.type == 'folder'));
        let el = document.getElementById('autoClosingViewFileModal');
        if (!!el) el.click();
        let deletables = this.all.filter(x => this.toBeDeleted.includes(x.id));
        let length = 0;
        if (!!this.caseId) {
            this.f.removeFilesFromCase(this.caseId, deletables.filter(x => x.type == 'file').map(x => x.id)).subscribe({
                next: () => { },
                error: (err) => { console.error('Could not delete files', this.toBeDeleted, err) },
                complete: () => {
                    length += deletables.filter(x => x.type == 'file').length;
                    if (length == deletables.length) this.getCaseFiles();
                }
            });
            deletables.filter(x => x.type == 'folder').forEach(x => {
                this.f.removeFolderFromCase(this.caseId, x.id).subscribe({
                    next: () => { },
                    error: (err) => { console.error('Could not delete files', this.toBeDeleted, err) },
                    complete: () => {
                        length += 1;
                        if (length == deletables.length) this.getCaseFiles();
                    }
                })
            })
        }
        else if (!!this.propertyId) {
            this.f.removeFilesFromProperty(this.propertyId, deletables.filter(x => x.type == 'file').map(x => x.id)).subscribe({
                next: () => { },
                error: (err) => { console.error('Could not delete files', this.toBeDeleted, err) },
                complete: () => {
                    length += deletables.filter(x => x.type == 'file').length;
                    if (length == deletables.length) this.getPropertyFiles();
                }
            });
            deletables.filter(x => x.type == 'folder').forEach(x => {
                this.f.removeFolderFromProperty(this.propertyId, x.id).subscribe({
                    next: () => { },
                    error: (err) => { console.error('Could not delete files', this.toBeDeleted, err) },
                    complete: () => {
                        length += 1;
                        if (length == deletables.length) this.getPropertyFiles();
                    }
                })
            })
        }
        else if (!!this.assetId) {
            let files = deletables.filter(x => x.type == 'file').map(x => x.id);
            let folders = deletables.filter(x => x.type == 'folder').map(x => x.id);
            if (!!files.length) {
                this.f.removeFilesFromAsset(this.assetId, files).subscribe({
                    complete: () => {
                        length += deletables.filter(x => x.type == 'file').length;
                        if (length == deletables.length) this.getAssetFiles();
                    }
                });
            }
            if (!!folders.length) {
                this.f.removeFoldersFromAsset(this.assetId, folders).subscribe({
                    complete: () => {
                        length += deletables.filter(x => x.type == 'folder').length;
                        if (length == deletables.length) this.getAssetFiles();
                    }
                });
            }
        }
    }

    fileHoverTable(event) {
        event.preventDefault()
        if (!!event && (!!this.folder && !!this.caseId || !this.caseId) && !this.dontDrop) this.fileHov = true;
        else this.fileHov = false;
    }

    prevent(ev) { ev.preventDefault() }

    fileHoverRow(event, x) {
        if (!!event) this.fileHov = false;
    }

    trackById(file) { return file.id }

    reload() {
        this.openFolders = this.checkOpenedFolders(this.folders);
        if (!!this.caseId) this.getCaseFiles();
        else if (!!this.propertyId) this.getPropertyFiles();
        else if (!!this.assetId) this.getAssetFiles();
        else if (!!this.serviceId) this.getServiceFiles();
    }

    addFolder() {
        let access = null;
        if (this.crumbs && this.crumbs.length) access = this.crumbs[0].fileAccess ?? this.getAccessFromParentFolder();
        console.log(this.crumbs)
        console.log(this.standardFolders)
        this.newFolder = { ...new FileFolder(), type: 'folder', parentId: this.folder, fileAccess: access };
        setTimeout(() => document.getElementById('newFilesFolderInput').focus(), 300);
    }

    getAccessFromParentFolder(): string | null {
        if (!this.crumbs || !this.crumbs.length || !this.standardFolders) return null;
        return this.crumbs[0].name == this.standardFolders.technician ? 'b296d35e-302d-42dc-8604-d4cb3bc284c7' : this.crumbs[0].name == this.standardFolders.administrator ? '71780049-0e58-4a78-991c-638f489c9232' : null;
    }

    createNewFolder() {
        if (!this.newFolder || !this.newFolder.name) this.newFolder = null;
        else {
            if (!!this.caseId) {
                // check the origin folder, for rights.
                // expect there to be a customer, technician and administrator folder.

                this.f.folderToCase(this.caseId, this.newFolder).subscribe(
                    {
                        next: (response) => {
                            this.newFolder.id = (typeof response == 'string') ? this.newFolder.id = response : response.success;
                            this.all.push(this.newFolder);
                            this.newFolder = null;
                            this.setFolder(this.folder);
                            this.sortFolderMenu();
                        },
                        error: (err) => { console.error('Folder could not be created'); this.newFolder = null; }
                    }
                )
            }
            else if (!!this.propertyId) {
                this.f.folderToProperty(this.propertyId, this.newFolder).subscribe(
                    {
                        next: (response) => {
                            this.newFolder.id = (typeof response == 'string') ? this.newFolder.id = response : response.success;
                            this.all.push(this.newFolder);
                            this.newFolder = null;
                            this.setFolder(this.folder);
                            this.sortFolderMenu();
                            // this.reload();
                        },
                        error: (err) => { console.error('Folder could not be created'); this.newFolder = null; }
                    }
                )
            }
            else if (!!this.assetId) {
                this.f.folderToAsset(this.assetId, this.newFolder).subscribe({
                    next: (response) => {
                        this.newFolder.id = (typeof response == 'string') ? this.newFolder.id = response : response.success;
                        this.all.push(this.newFolder);
                        this.newFolder = null;
                        this.setFolder(this.folder);
                        this.sortFolderMenu();
                    }
                })
            }
            else if (!!this.serviceId) {
                this.newFolder.fileAccess = "B296D35E-302D-42DC-8604-D4CB3BC284C7";
                this.f.folderToService(this.serviceId, this.newFolder).subscribe({
                    next: (response) => {
                        this.newFolder.id = (typeof response == 'string') ? this.newFolder.id = response : response.success;
                        this.all.push(this.newFolder);
                        this.newFolder = null;
                        this.setFolder(this.folder);
                        this.sortFolderMenu();
                    }
                })
            }
        }
    }

    async sortFolderMenu() {
        let folderTree = Objectify.arrayToTree(this.all.filter(x => !x.extension), 'id', 'parentId');
        if (!!this.caseId) {
            this.folders = folderTree.sort((a, b) => {
                if ((a.name == this.standardFolders.customer && b.name != this.standardFolders.customer) || (a.name != this.standardFolders.customer && b.name == this.standardFolders.customer)) return a.name == this.standardFolders.customer ? -1 : 1;
                if (a.name == this.standardFolders.technician || b.name == this.standardFolders.technician) return a.name == this.standardFolders.technician ? -1 : 1;
                if (a.name == this.standardFolders.administrator || b.name == this.standardFolders.administrator) return a.name == this.standardFolders.administrator ? -1 : 1;
                if (a.name == 'Ordrestyring' || b.name == 'Ordrestyring') a.name == 'Ordrestyring' ? 1 : -1;
                return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
            });
        } else {
            this.folders = folderTree.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)
        }

        for (let x of this.folders) {
            x.count = await this.countChildImages(x)
        };
    }

    async countChildImages(f: any): Promise<number> {
        let myCount = 0;
        let children = this.all.filter(x => x.parentId == f.id);
        for (let x of children.filter(x => x.type == 'folder')) {
            myCount += await this.countChildImages(x)
        }
        myCount += children.filter(x => x.type == 'file').length
        f.count = myCount;
        return myCount
    }

    folderDropEvent(event) {
        if (event.type == 'add' && !!event.content.length) {
            // Change folder to dropped folder, so that files will be visible on reload. Should not change on move.
            this.folder = event.folderId;
            this.addFiles(event.content);
        }
        else if (event.type == 'move') this.moveFiles(event)
    }

    drag(event: DragEvent, x) {
        // event.preventDefault();
        x.selected = true;
        this.filesSelected = CaseFilesFunctions.checkCurrentSelected(this.current);
        event.dataTransfer.setData('text', JSON.stringify(x));
    }

    checkOpenedFolders(folders): string[] {
        let open = [];
        folders.forEach(x => {
            if (!!x.children.length) open = open.concat(this.checkOpenedFolders(x.children));
            if (!!x.open) open.push(x.id)
        });
        return open
    }

    downloadFiles() {
        let downloadables = this.current.filter(x => !!x.selected);
        downloadables.forEach(x => {
            if (x.type == 'file') {
                let el = document.createElement('a');
                el.target = '_blank';
                el.href = api.jubloApi + 'api/shared/attachments/' + x.id;
                el.click();
            }
            x.selected = false;
        });
        this.filesSelected = CaseFilesFunctions.checkCurrentSelected(this.current);
    }

    getURL(id) {
        return api.jubloApi + 'api/shared/attachments/' + id + '?userId=' + localStorage.getItem('bearer');
    }

    indexOf(id) {
        let files = this.current.filter(x => x.type == 'file').map(x => x.id);
        return (files.indexOf(id) + 1) + ' ' + this.translate.instant('Word.Of').toLowerCase() + ' ' + files.length
    }

    notFirstFile(id) {
        let files = this.current.filter(x => x.type == 'file').map(x => x.id);
        return files.indexOf(id) != 0;
    }

    notLastFile(id) {
        let files = this.current.filter(x => x.type == 'file').map(x => x.id);
        return files.indexOf(id) != files.length - 1;
    }

    setNextViewFile(num: number) {
        let files = this.current.filter(x => x.type == 'file').map(x => x.id);
        let x = this.current.filter(x => x.type == 'file')[files.indexOf(this.viewFile.id) + num];
        if (x.extension == '.pdf') {
            this.displayDoc = fetch(this.getURL(x.id)).then(res => res.blob()).then(blob => {
                this.displayDoc = URL.createObjectURL(blob);
                this.viewFile = x;
            })
        }
        else this.viewFile = x;
    }

    renameFolder(folder: IdName) {
        this.f.renameFolder(folder).subscribe({
            next: () => { },
            error: (err) => { console.error(err) },
            complete: () => this.sortFolderMenu()
        });
    }
}

type FileTargetType = 'case' | 'property' | 'asset' | 'service';